import React from 'react';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown';
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';


const FeaturesPage = ({ pageContext: { locale }, ...props }) => {
  const { node: data } = props.data.FeaturesPageData.edges[0]

  return (
    <Layout>
      <Helmet>
        <html lang={locale === 'en' ? 'en' : 'de'} />
        <title>
          { 
            locale === 'en' ?
              'Features - presono' :
              'Features - presono'
          }
        </title>
        <meta
          name="description"
          content={ 
            locale === 'en' ?
              'Many innovative features enable you to create professional presentations' :
              'Viele innovative Funktionen ermöglichen es Ihnen, professionelle Präsentationen zu erstellen'
          }
        />

      </Helmet>
      <Navigation langSwitch={data.frontmatter.langSwitch} locale={locale} />
      <section className="features">
        <section className="headliner topbar starfield t1 b4">
          <div className="container">
            <div class="column">
              <ReactMarkdown source={data.frontmatter.featuresHeadline} />
              <p>
                { data.frontmatter.featuresHeadlineSubtext }
              </p>
            </div>
          </div>
        </section>
        <div class="container">
          <div class="tile is-ancestor">
            <div class="tile is-vertical is-12">
              <div class="tile">
                <div class="tile is-parent is-8">
                  <div class="inner">
                    <div class="backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature1Image.relativePath})` }}>

                    </div>
                    <div class="bottom">
                      <div class="content">
                        <h3>{ data.frontmatter.feature1Headline }</h3>
                        <p>{ data.frontmatter.feature1Text }</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tile is-parent is-4">
                  <div class="inner">
                    <div class="backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature2Image.relativePath})` }}>
                    </div>
                    <div class="bottom">
                      <div class="content">
                        <h3>{ data.frontmatter.feature2Headline }</h3>
                        <p>{ data.frontmatter.feature2Text }</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tile">
                <div class="tile is-parent is-12">
                  <div class="inner">
                    <div class="columns nomargin">
                      <div class="column left is-8 backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature3Image.relativePath})` }}>
                      </div>
                      <div class="column right is-4">
                        <div class="content">
                          <h3>{ data.frontmatter.feature3Headline }</h3>
                          <p>{ data.frontmatter.feature3Text }</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tile">
                <div class="tile is-parent is-4">
                  <div class="inner">
                  <div class="backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature4Image.relativePath})` }}>

                    </div>
                    <div class="bottom">
                      <div class="content">
                        <h3>{ data.frontmatter.feature4Headline }</h3>
                        <p>{ data.frontmatter.feature4Text }</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tile is-parent is-4">
                  <div class="inner">
                  <div class="backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature5Image.relativePath})` }}>

                    </div>
                    <div class="bottom">
                      <div class="content">
                        <h3>{ data.frontmatter.feature5Headline }</h3>
                        <p>{ data.frontmatter.feature5Text }</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tile is-parent is-4">
                  <div class="inner">
                    <div class="backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature6Image.relativePath})` }}>

                    </div>
                    <div class="bottom">
                      <div class="content">
                        <h3>{ data.frontmatter.feature6Headline }</h3>
                        <p>{ data.frontmatter.feature6Text }</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tile">
                <div class="tile is-parent is-4">
                  <div class="inner">
                    <div class="backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature7Image.relativePath})` }}>
                    </div>
                    <div class="bottom">
                      <div class="content">
                        <h3>{ data.frontmatter.feature7Headline }</h3>
                        <p>{ data.frontmatter.feature7Text }</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tile is-parent is-8">
                  <div class="inner">
                    <div class="backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature8Image.relativePath})` }}>

                    </div>
                    <div class="bottom">
                      <div class="content">
                        <h3>{ data.frontmatter.feature8Headline }</h3>
                        <p>{ data.frontmatter.feature8Text }</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tile">
                <div class="tile is-parent is-4">
                  <div class="inner">
                    <div class="backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature9Image.relativePath})` }}>

                    </div>
                    <div class="bottom">
                      <div class="content">
                        <h3>{ data.frontmatter.feature9Headline }</h3>
                        <p>{ data.frontmatter.feature9Text }</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tile is-parent is-4">
                  <div class="inner">
                    <div class="backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature10Image.relativePath})` }}>

                    </div>
                    <div class="bottom">
                      <div class="content">
                        <h3>{ data.frontmatter.feature10Headline }</h3>
                        <p>{ data.frontmatter.feature10Text }</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tile is-parent is-4">
                  <div class="inner">
                    <div class="backgroundImg top" style={{ backgroundImage: `url(${'/img/'+ data.frontmatter.feature11Image.relativePath})` }}>

                    </div>
                    <div class="bottom">
                      <div class="content">
                        <h3>{ data.frontmatter.feature11Headline }</h3>
                        <p>{ data.frontmatter.feature11Text }</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Newsletter newsletter={data.frontmatter} locale={locale} />
      <Footer locale={locale} />
    </Layout>
  )
}

export default FeaturesPage;

FeaturesPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
query FeaturesContent($locale: String) {
  FeaturesPageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_features"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          featuresHeadline
          featuresHeadlineSubtext
          feature1Headline
          feature1Text
          feature1Image {
            name
            relativePath
          }
          feature2Headline
          feature2Text
          feature2Image {
            name
            relativePath
          }
          feature3Headline
          feature3Text
          feature3Image {
            name
            relativePath
          }
          feature4Headline
          feature4Text
          feature4Image {
            name
            relativePath
          }
          feature5Headline
          feature5Text
          feature5Image {
            name
            relativePath
          }
          feature6Headline
          feature6Text
          feature6Image {
            name
            relativePath
          }
          feature7Headline
          feature7Text
          feature7Image {
            name
            relativePath
          }
          feature8Headline
          feature8Text
          feature8Image {
            name
            relativePath
          }
          feature9Headline
          feature9Text
          feature9Image {
            name
            relativePath
          }
          feature10Headline
          feature10Text
          feature10Image {
            name
            relativePath
          }
          feature11Headline
          feature11Text
          feature11Image {
            name
            relativePath
          }
          langSwitch
        }
      }
    }
  }
}
`
